import { Link } from "react-router-dom";

export const AuthShell = ({ title, subtitle, children, footer }) => {
  return (
    <div className="min-h-screen w-full bg-[#F7F7F8]" data-testid="auth-shell">
      <header className="h-14 px-4 sm:px-6 flex items-center justify-between border-b border-[#E5E7EB] bg-white">
        <Link to="/business/login" className="flex items-center gap-2" data-testid="auth-shell-logo-link">
          <img
            src="https://customer-assets.emergentagent.com/job_web-deploy-pkg/artifacts/zb69b8pm_AnZuo.png"
            alt="BuskerBeat"
            className="h-8 w-8 rounded-lg object-contain"
          />
          <span className="font-semibold tracking-tight text-[#111827]">BuskerBeat <span className="text-[#FF6A00]">Business</span></span>
        </Link>
        <a href="/" className="text-sm text-[#6B7280] hover:text-[#111827]" data-testid="auth-shell-back-to-marketing">← Back to buskerbeat.com</a>
      </header>
      <main className="flex items-start justify-center px-4 py-10">
        <div className="w-full max-w-md">
          <div className="mb-6 text-center">
            <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-[#111827]" data-testid="auth-shell-title">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-[#6B7280]" data-testid="auth-shell-subtitle">{subtitle}</p>}
          </div>
          <div className="rounded-2xl bg-white border border-[#E5E7EB] shadow-sm p-6 sm:p-8">
            {children}
          </div>
          {footer && <div className="mt-5 text-center text-sm text-[#6B7280]">{footer}</div>}
        </div>
      </main>
    </div>
  );
};
